import React, { useEffect, useState, useMemo, useRef } from 'react'
import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { checkUploadStatus, alert, toaster } from '../../../../../utils/helper'
import { useMutation } from '@apollo/client'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'

import { useFormik } from 'formik'
import { UPLOAD_AGENTS, CREATE_AGENTS, CREATE_AGENTS_WITH_USERID_PASSWORD, UPLOAD_AGENTS_USERID_PASSWORD } from '../../../../../utils/GraphQLAPI'

import AddAgent from '../steps/AddAgent'

import * as Yup from 'yup'
import uuid from 'react-uuid'
type Props = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  salesChannelId?: string
  agentLeaderList: any
  handleCreateAgentSubmit: any
}

const EMPTY_FORM = { agent: [], agentLeaders: [] }

const CreateAgentModel = ({
  show,
  handleClose,
  refetchList,
  salesChannelId,
  agentLeaderList,
  handleCreateAgentSubmit,
}: Props) => {
  const initialFormValue = useMemo(() => ({
    agent: [],
    agentLeaders: agentLeaderList,
  }), [agentLeaderList])
  const [generatedTrackId, setGenerateTrackId] = useState<any>('')
  const [isSubmit, setIsSubmit] = useState(false)
  const [activeStatus, setActiveStatus] = useState<boolean>(false)
  const modalsRoot = useRef<Element>(document.getElementById('root-modals') || document.body)

  useEffect(() => {
    setGenerateTrackId(uuid())
  }, [])
  const successMessage = 'Agent created successfully'
  const [uploadAgent] = useMutation(UPLOAD_AGENTS, {
    onCompleted: (data) => {
      if (data.uploadAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.uploadAgents, 'warning')
      } else if (data.uploadAgents.includes(successMessage)) {
        toaster(data.uploadAgents, 'success')
      } else if (data.uploadAgents.includes(generatedTrackId)) {
        toaster(successMessage, 'success')
      }
      else {
        toaster(data.uploadAgents, 'error')
        return  // This line was added to handle the case where the uploadAgents response does not match expected values  
      }
      checkUploadStatus(generatedTrackId, refetchList)
      handleHide()
      formik.setValues(initialFormValue)
    },
    onError: (error) => {
      alert(error.message, 'error')
      handleHide()
    },
  })

  const [uploadAgentWithPassword] = useMutation(UPLOAD_AGENTS_USERID_PASSWORD, {
    onCompleted: (data) => {
      if (data.uploadAgentsUserNameFlow.includes('got failed while creating, Email has been sent')) {
        toaster(data.uploadAgentsUserNameFlow, 'warning')
      } else if (data.uploadAgentsUserNameFlow.includes(successMessage)) {
        toaster(data.uploadAgentsUserNameFlow, 'success')
      } else if (data.uploadAgentsUserNameFlow.includes(generatedTrackId)) {
        toaster(successMessage, 'success')
      }
      else {
        toaster(data.uploadAgentsUserNameFlow, 'error')
        return  // This line was added to handle the case where the uploadAgents response does not match expected values  
      }
      checkUploadStatus(generatedTrackId, refetchList)
      handleHide()
      formik.setValues(initialFormValue)
    },
    onError: (error) => {
      alert(error.message, 'error')
      handleHide()
    },
  })
  const validationSchema = Yup.object().shape({
    agent: Yup.array().of(
      Yup.object().shape({
        agentFirstName: Yup.string().required('First Name is required'),
        agentLastName: Yup.string().required('Last Name is required'),
        UserName: Yup.string()
          .required('User ID is required')
          .min(7, 'Minimum 7 characters are required')
          .max(15, 'Maximum 15 characters are allowed')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{7,}$/,
            'Username must contain at least one uppercase, one lowercase, and one number (Example: TpvSolutions123)'
          ), agentPassword: Yup.string()
            .min(8, 'Minimum 8 characters are required')
            .max(15, 'Maximum 15 characters are allowed')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d`~!@#$%^&*()_+=\-{}|[\]:;"'<>,.?\/]{8,}$/,
              'Password must be at least 8 characters, include uppercase, lowercase, number, and symbol (Example:TpvSolutions@123)'
            ).required('Password is required'),
      })
    ),
  })

  const emailValidationSchema = Yup.object().shape({
    agent: Yup.array().of(
      Yup.object().shape({
        agentFirstName: Yup.string().required('First Name is required'),
        agentLastName: Yup.string().required('Last Name is required'),
        agentEmailID: Yup.string().required('Email ID is required'),

      })
    ),
  })
  const formik = useFormik({
    initialValues: EMPTY_FORM,
    validationSchema: activeStatus ? emailValidationSchema : validationSchema,
    validateOnMount: true,
    onSubmit: () => {
      const agentValue: any = formik.getFieldMeta('agent').value
      handleCreateAgentSubmit(
        agentValue,
        createAgents,
        uploadAgent,
        generatedTrackId,
        salesChannelId,
        createAgentsWithPassword,
        activeStatus,
        uploadAgentWithPassword

      )
      // refetchList()
    },
  })

  // Sync Call
  const [createAgents, { loading: isLoadingAgentCreate }] = useMutation(CREATE_AGENTS, {
    onCompleted: async (data) => {
      if (data.createAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.createAgents, 'warning')
      } else if (data.createAgents.includes(successMessage)) {
        toaster(data.createAgents, 'success')
      } else {
        toaster(data.createAgents, 'error')
      }
      handleHide()
      refetchList()
      formik.setValues(initialFormValue)
    },
    onError: (error) => toaster(error.message, 'error'),
  })
  const [createAgentsWithPassword, { loading: isLoadingUserNameFlow }] = useMutation(CREATE_AGENTS_WITH_USERID_PASSWORD, {
    onCompleted: async (data) => {
      if (data.createAgentsUserNameFlow.includes('got failed while creating, Email has been sent')) {
        toaster(data.createAgentsUserNameFlow, 'warning')
      } else if (data.createAgentsUserNameFlow.includes(successMessage)) {
        toaster(data.createAgentsUserNameFlow, 'success')
      } else {
        toaster(data.createAgentsUserNameFlow, 'error')
      }
      handleHide()
      refetchList()
      formik.setValues(initialFormValue)
    },
    onError: (error) => toaster(error.message, 'error'),
  })


  const handleHide = () => {
    formik.resetForm()
    handleClose()
    setActiveStatus(false)
  }
  const agentLeaderListStr = JSON.stringify(agentLeaderList)

  useEffect(() => {
    if (agentLeaderList?.length) {
      formik.setFieldValue('agentLeaders', agentLeaderList)
    }
  }, [agentLeaderListStr])

  if (!modalsRoot.current) return null

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      size='xl'
      aria-hidden='true'
      dialogClassName='modal-dialog-scrollable modal-fullscreen'
      fullscreen='xxl-down'
      show={show}
      onHide={handleHide}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title '>Add Agent</h4>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleHide}>
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <AddAgent formik={formik} setIsSubmit={setIsSubmit} setActiveStatus={setActiveStatus} activeStatus={activeStatus} />
      </div>
      <div className='modal-footer'>
        <button
          type='button'
          className='btn btn-light'
          data-bs-dismiss='modal'
          onClick={handleHide}
        >
          Discard
        </button>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={formik.values.agent.length === 0 ||
            !formik.isValid || isLoadingAgentCreate || isLoadingUserNameFlow}
          onClick={() => formik.submitForm()}
        >
          Submit
          {
            (isLoadingAgentCreate || isLoadingUserNameFlow) && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )
          }
        </button>
      </div>
    </Modal>,
    modalsRoot.current
  )
}

export { CreateAgentModel }
